module.exports = __webpack_public_path__ + "static/grass-3b06aa0baa7aefa30c29cbc35a8a2de4.png";